import { render } from "./DashboardTopStaff.vue?vue&type=template&id=6159e594&ts=true"
import script from "./DashboardTopStaff.vue?vue&type=script&lang=ts"
export * from "./DashboardTopStaff.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__